<template>
  <div>
    <h2 class="title">Premier article</h2>
    <form @submit.prevent="next">
      <div class="field">
        <label class="label">Nom de l’article</label>
        <input v-model="form.name" class="input" type="text" required />
      </div>

      <div class="field">
        <label class="label">Prix unitaire</label>
        <input
          v-model.number="form.unit_price"
          class="input"
          type="number"
          min="0"
          step="0.01"
        />
      </div>

      <div class="field">
        <label class="label">Description</label>
        <textarea v-model="form.description" class="textarea"></textarea>
      </div>

      <button class="button is-light" @click="$emit('prev')" type="button">
        Back
      </button>
      <button class="button is-primary" type="submit">Next</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        unit_price: 0,
        description: '',
      },
    };
  },
  methods: {
    next() {
      // 🚀 Emit local data to parent wizard
      this.$emit('next', { firstItem: this.form });
    },
  },
};
</script>
